/**
 * 组织管理菜单图标显示修复补丁
 * 直接修复可能导致图标不显示的具体问题
 */

import {
  AccountBookOutlined,
  // TwoTone 图标 (按字母顺序排列)
  AccountBookTwoTone,
  // Filled 图标
  AlertFilled,
  AlertTwoTone,
  AlibabaOutlined,
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  AliyunOutlined,
  AmazonOutlined,
  AndroidOutlined,
  AntCloudOutlined,
  ApartmentOutlined,
  ApiOutlined,
  ApiTwoTone,
  AppleOutlined,
  AppstoreOutlined,
  AppstoreTwoTone,
  AreaChartOutlined,
  ArrowsAltOutlined,
  AudioOutlined,
  AudioTwoTone,
  BackwardOutlined,
  BankOutlined,
  BankTwoTone,
  BarChartOutlined,
  BarsOutlined,
  BellOutlined,
  BellTwoTone,
  BoldOutlined,
  BookOutlined,
  BookTwoTone,
  BoxPlotOutlined,
  BoxPlotTwoTone,
  BranchesOutlined,
  BugOutlined,
  BugTwoTone,
  BuildOutlined,
  BuildTwoTone,
  BulbOutlined,
  BulbTwoTone,
  CalculatorOutlined,
  CalculatorTwoTone,
  CalendarOutlined,
  CalendarTwoTone,
  CameraOutlined,
  CameraTwoTone,
  CaretDownOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  CaretUpOutlined,
  CarOutlined,
  CarryOutTwoTone,
  CarTwoTone,
  CheckCircleOutlined,
  CheckCircleTwoTone,
  CheckSquareTwoTone,
  ChromeOutlined,
  CiCircleTwoTone,
  CiTwoTone,
  ClockCircleOutlined,
  ClockCircleTwoTone,
  CloseCircleOutlined,
  CloseCircleTwoTone,
  CloseSquareTwoTone,
  CloudOutlined,
  CloudTwoTone,
  ClusterOutlined,
  CodepenOutlined,
  CodeSandboxOutlined,
  CodeTwoTone,
  CoffeeOutlined,
  CommentOutlined,
  CompassOutlined,
  CompassTwoTone,
  ContactsOutlined,
  ContactsTwoTone,
  ContainerOutlined,
  ContainerTwoTone,
  ControlOutlined,
  ControlTwoTone,
  CopyOutlined,
  CopyrightCircleTwoTone,
  CopyrightOutlined,
  CopyrightTwoTone,
  CopyTwoTone,
  CreditCardTwoTone,
  CrownOutlined,
  CrownTwoTone,
  CustomerServiceOutlined,
  CustomerServiceTwoTone,
  DashboardOutlined,
  DashboardTwoTone,
  DashOutlined,
  DatabaseOutlined,
  DatabaseTwoTone,
  DeleteOutlined,
  DeleteTwoTone,
  DesktopOutlined,
  DiffOutlined,
  DiffTwoTone,
  DisconnectOutlined,
  DislikeOutlined,
  DislikeTwoTone,
  DollarCircleTwoTone,
  DollarTwoTone,
  DotChartOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  DownCircleTwoTone,
  DownloadOutlined,
  DownOutlined,
  DownSquareTwoTone,
  DribbbleSquareFilled,
  EditOutlined,
  EditTwoTone,
  EllipsisOutlined,
  EnterOutlined,
  EnvironmentOutlined,
  EnvironmentTwoTone,
  EuroCircleTwoTone,
  EuroTwoTone,
  ExceptionOutlined,
  ExclamationCircleOutlined,
  ExclamationCircleTwoTone,
  ExperimentOutlined,
  ExperimentTwoTone,
  EyeInvisibleTwoTone,
  EyeOutlined,
  EyeTwoTone,
  FacebookFilled,
  FastBackwardOutlined,
  FastForwardOutlined,
  FileAddOutlined,
  FileAddTwoTone,
  FileDoneOutlined,
  FileExcelOutlined,
  FileExcelTwoTone,
  FileExclamationOutlined,
  FileExclamationTwoTone,
  FileGifOutlined,
  FileImageTwoTone,
  FileMarkdownOutlined,
  FileMarkdownTwoTone,
  FilePdfOutlined,
  FilePdfTwoTone,
  FilePptOutlined,
  FilePptTwoTone,
  FileProtectOutlined,
  FileSyncOutlined,
  FileTextOutlined,
  FileTextTwoTone,
  FileTwoTone,
  FileUnknownOutlined,
  FileUnknownTwoTone,
  FileWordOutlined,
  FileWordTwoTone,
  FileZipOutlined,
  FileZipTwoTone,
  FilterOutlined,
  FilterTwoTone,
  FireOutlined,
  FireTwoTone,
  FlagOutlined,
  FlagTwoTone,
  FolderAddOutlined,
  FolderAddTwoTone,
  FolderOpenOutlined,
  FolderOpenTwoTone,
  FolderOutlined,
  FolderTwoTone,
  FontColorsOutlined,
  FontSizeOutlined,
  ForkOutlined,
  FormOutlined,
  ForwardOutlined,
  FrownOutlined,
  FrownTwoTone,
  FullscreenExitOutlined,
  FullscreenOutlined,
  FunctionOutlined,
  FundOutlined,
  FundTwoTone,
  FunnelPlotTwoTone,
  GifOutlined,
  GiftOutlined,
  GiftTwoTone,
  GithubOutlined,
  GitlabOutlined,
  GlobalOutlined,
  GoldOutlined,
  GoldTwoTone,
  GoogleOutlined,
  HarmonyOSOutlined,
  HddOutlined,
  HddTwoTone,
  HeartOutlined,
  HeartTwoTone,
  HeatMapOutlined,
  HighlightOutlined,
  HighlightTwoTone,
  HistoryOutlined,
  HomeOutlined,
  HomeTwoTone,
  HourglassOutlined,
  HourglassTwoTone,
  Html5TwoTone,
  IdcardOutlined,
  IdcardTwoTone,
  IeOutlined,
  ImportOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  InfoCircleTwoTone,
  InfoOutlined,
  InsertRowAboveOutlined,
  InsertRowBelowOutlined,
  InsertRowLeftOutlined,
  InsertRowRightOutlined,
  InstagramFilled,
  InsuranceTwoTone,
  InteractionOutlined,
  InteractionTwoTone,
  IssuesCloseOutlined,
  ItalicOutlined,
  JavaOutlined,
  JavaScriptOutlined,
  KeyOutlined,
  KubernetesOutlined,
  LaptopOutlined,
  LayoutTwoTone,
  LeftCircleTwoTone,
  LeftOutlined,
  LeftSquareTwoTone,
  LikeOutlined,
  LikeTwoTone,
  LineChartOutlined,
  LineHeightOutlined,
  LineOutlined,
  LinkedinOutlined,
  LinuxOutlined,
  Loading3QuartersOutlined,
  LoadingOutlined,
  LockOutlined,
  LockTwoTone,
  LoginOutlined,
  LogoutOutlined,
  MacCommandOutlined,
  MailOutlined,
  MailTwoTone,
  MedicineBoxOutlined,
  MedicineBoxTwoTone,
  MehOutlined,
  MehTwoTone,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  MergeCellsOutlined,
  MergeOutlined,
  MessageOutlined,
  MessageTwoTone,
  MinusCircleOutlined,
  MinusCircleTwoTone,
  MinusSquareOutlined,
  MinusSquareTwoTone,
  MobileTwoTone,
  MoneyCollectTwoTone,
  MonitorOutlined,
  MoonOutlined,
  MoreOutlined,
  MutedOutlined,
  NodeCollapseOutlined,
  NodeExpandOutlined,
  NodeIndexOutlined,
  NotificationOutlined,
  NotificationTwoTone,
  NumberOutlined,
  OneToOneOutlined,
  OpenAIOutlined,
  OrderedListOutlined,
  PaperClipOutlined,
  PartitionOutlined,
  PauseCircleTwoTone,
  PayCircleOutlined,
  PhoneOutlined,
  PhoneTwoTone,
  PicCenterOutlined,
  PicLeftOutlined,
  PicRightOutlined,
  PictureOutlined,
  PictureTwoTone,
  PieChartOutlined,
  PieChartTwoTone,
  PinterestOutlined,
  PlayCircleTwoTone,
  PlaySquareTwoTone,
  PlusCircleOutlined,
  PlusCircleTwoTone,
  PlusOutlined,
  PlusSquareOutlined,
  PlusSquareTwoTone,
  PoundCircleTwoTone,
  PoundOutlined,
  PoweroffOutlined,
  PrinterTwoTone,
  ProductOutlined,
  ProfileTwoTone,
  ProjectTwoTone,
  PropertySafetyTwoTone,
  PullRequestOutlined,
  PushpinOutlined,
  PushpinTwoTone,
  PythonOutlined,
  QqOutlined,
  QrcodeOutlined,
  QuestionCircleOutlined,
  QuestionCircleTwoTone,
  QuestionOutlined,
  RadarChartOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
  ReadOutlined,
  ReconciliationTwoTone,
  RedEnvelopeTwoTone,
  RedoOutlined,
  ReloadOutlined,
  RestOutlined,
  RestTwoTone,
  RetweetOutlined,
  RightCircleTwoTone,
  RightOutlined,
  RightSquareTwoTone,
  RiseOutlined,
  RocketOutlined,
  RocketTwoTone,
  RollbackOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  RubyOutlined,
  SafetyCertificateOutlined,
  SafetyCertificateTwoTone,
  SaveOutlined,
  SaveTwoTone,
  ScanOutlined,
  ScheduleTwoTone,
  ScissorOutlined,
  SearchOutlined,
  SecurityScanOutlined,
  SecurityScanTwoTone,
  SelectOutlined,
  SettingOutlined,
  SettingTwoTone,
  ShakeOutlined,
  ShareAltOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  ShoppingTwoTone,
  ShopTwoTone,
  ShrinkOutlined,
  SignalFilled,
  SignatureOutlined,
  SkinOutlined,
  SkinTwoTone,
  SkypeOutlined,
  SlackOutlined,
  SlackSquareOutlined,
  SlidersOutlined,
  SlidersTwoTone,
  SmallDashOutlined,
  SmileOutlined,
  SmileTwoTone,
  SnippetsOutlined,
  SnippetsTwoTone,
  SolutionOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  SoundOutlined,
  SoundTwoTone,
  SplitCellsOutlined,
  SpotifyOutlined,
  StarOutlined,
  StarTwoTone,
  StepBackwardOutlined,
  StepForwardOutlined,
  StockOutlined,
  StopOutlined,
  StopTwoTone,
  StrikethroughOutlined,
  SubnodeOutlined,
  SunOutlined,
  SwapLeftOutlined,
  SwapOutlined,
  SwapRightOutlined,
  SwitcherFilled,
  SwitcherTwoTone,
  SyncOutlined,
  TableOutlined,
  TabletOutlined,
  TabletTwoTone,
  TagOutlined,
  TagsOutlined,
  TagsTwoTone,
  TagTwoTone,
  TaobaoCircleFilled,
  TaobaoSquareFilled,
  TeamOutlined,
  ThunderboltOutlined,
  ThunderboltTwoTone,
  ToolTwoTone,
  ToTopOutlined,
  TrademarkCircleTwoTone,
  TrademarkOutlined,
  TransactionOutlined,
  TranslationOutlined,
  TrophyOutlined,
  TrophyTwoTone,
  TruckOutlined,
  TwitchOutlined,
  TwitterCircleFilled,
  TwitterOutlined,
  TwitterSquareFilled,
  UndoOutlined,
  UngroupOutlined,
  UnlockOutlined,
  UnlockTwoTone,
  UnorderedListOutlined,
  UpCircleTwoTone,
  UploadOutlined,
  UpOutlined,
  UpSquareTwoTone,
  UsbFilled,
  UsbTwoTone,
  UserAddOutlined,
  UserOutlined,
  VerifiedOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
  VideoCameraAddOutlined,
  VideoCameraOutlined,
  VideoCameraTwoTone,
  WalletTwoTone,
  WarningOutlined,
  WarningTwoTone,
  WechatOutlined,
  WeiboCircleOutlined,
  WeiboOutlined,
  WeiboSquareOutlined,
  WhatsAppOutlined,
  WifiOutlined,
  WindowsOutlined,
  XOutlined,
  YahooOutlined,
  YoutubeOutlined,
  YuqueOutlined,
  ZhihuOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from '@ant-design/icons';
import * as React from 'react';

const FIXED_ICON_MAPPING: Record<string, string> = {
  organization: 'ApartmentOutlined',
  组织管理: 'ApartmentOutlined',
  org: 'ApartmentOutlined',
  apartment: 'ApartmentOutlined',
  employee: 'UserOutlined',
  员工管理: 'UserOutlined',
  user: 'UserOutlined',
  department: 'TeamOutlined',
  部门管理: 'TeamOutlined',
  dept: 'TeamOutlined',
  team: 'TeamOutlined',
  position: 'IdcardOutlined',
  岗位管理: 'IdcardOutlined',
  post: 'IdcardOutlined',
  idcard: 'IdcardOutlined',
};

const getIconComponent = (
  iconName: string,
): React.ComponentType<any> | null => {
  switch (iconName) {
    case 'ApartmentOutlined':
      return ApartmentOutlined;
    case 'UserOutlined':
      return UserOutlined;
    case 'TeamOutlined':
      return TeamOutlined;
    case 'IdcardOutlined':
      return IdcardOutlined;
    case 'HomeOutlined':
      return HomeOutlined;
    case 'SettingOutlined':
      return SettingOutlined;
    case 'AppstoreOutlined':
      return AppstoreOutlined;
    case 'FileTextOutlined':
      return FileTextOutlined;
    case 'SafetyCertificateOutlined':
      return SafetyCertificateOutlined;
    case 'SolutionOutlined':
      return SolutionOutlined;
    case 'ContactsOutlined':
      return ContactsOutlined;
    case 'MailOutlined':
      return MailOutlined;
    case 'CalendarOutlined':
      return CalendarOutlined;
    case 'PictureOutlined':
      return PictureOutlined;
    case 'VideoCameraOutlined':
      return VideoCameraOutlined;
    case 'UploadOutlined':
      return UploadOutlined;
    case 'DownloadOutlined':
      return DownloadOutlined;
    case 'SearchOutlined':
      return SearchOutlined;
    case 'EditOutlined':
      return EditOutlined;
    case 'DeleteOutlined':
      return DeleteOutlined;
    case 'PlusOutlined':
      return PlusOutlined;
    case 'EyeOutlined':
      return EyeOutlined;
    case 'LockOutlined':
      return LockOutlined;
    case 'UnlockOutlined':
      return UnlockOutlined;
    case 'ShareAltOutlined':
      return ShareAltOutlined;
    case 'LikeOutlined':
      return LikeOutlined;
    case 'DislikeOutlined':
      return DislikeOutlined;
    case 'StarOutlined':
      return StarOutlined;
    case 'FilterOutlined':
      return FilterOutlined;
    case 'SortAscendingOutlined':
      return SortAscendingOutlined;
    case 'SortDescendingOutlined':
      return SortDescendingOutlined;
    case 'ReloadOutlined':
      return ReloadOutlined;
    case 'SyncOutlined':
      return SyncOutlined;
    case 'PoweroffOutlined':
      return PoweroffOutlined;
    case 'LogoutOutlined':
      return LogoutOutlined;
    case 'LoginOutlined':
      return LoginOutlined;
    case 'UserAddOutlined':
      return UserAddOutlined;
    case 'GroupOutlined':
      return TeamOutlined;
    case 'BarsOutlined':
      return BarsOutlined;
    case 'MenuFoldOutlined':
      return MenuFoldOutlined;
    case 'MenuUnfoldOutlined':
      return MenuUnfoldOutlined;
    case 'UnorderedListOutlined':
      return UnorderedListOutlined;
    case 'OrderedListOutlined':
      return OrderedListOutlined;
    case 'FormOutlined':
      return FormOutlined;
    case 'TableOutlined':
      return TableOutlined;
    case 'AreaChartOutlined':
      return AreaChartOutlined;
    case 'PieChartOutlined':
      return PieChartOutlined;
    case 'BarChartOutlined':
      return BarChartOutlined;
    case 'DotChartOutlined':
      return DotChartOutlined;
    case 'LineChartOutlined':
      return LineChartOutlined;
    case 'RadarChartOutlined':
      return RadarChartOutlined;
    case 'HeatMapOutlined':
      return HeatMapOutlined;
    case 'NotificationOutlined':
      return NotificationOutlined;
    case 'MessageOutlined':
      return MessageOutlined;
    case 'CommentOutlined':
      return CommentOutlined;
    case 'CustomerServiceOutlined':
      return CustomerServiceOutlined;
    case 'PhoneOutlined':
      return PhoneOutlined;
    case 'TabletOutlined':
      return TabletOutlined;
    case 'LaptopOutlined':
      return LaptopOutlined;
    case 'DesktopOutlined':
      return DesktopOutlined;
    case 'QrcodeOutlined':
      return QrcodeOutlined;
    case 'ScanOutlined':
      return ScanOutlined;
    case 'ExceptionOutlined':
      return ExceptionOutlined;
    case 'IssuesCloseOutlined':
      return IssuesCloseOutlined;
    case 'StopOutlined':
      return StopOutlined;
    case 'InfoCircleOutlined':
      return InfoCircleOutlined;
    case 'QuestionCircleOutlined':
      return QuestionCircleOutlined;
    case 'ExclamationCircleOutlined':
      return ExclamationCircleOutlined;
    case 'CloseCircleOutlined':
      return CloseCircleOutlined;
    case 'CheckCircleOutlined':
      return CheckCircleOutlined;
    case 'WarningOutlined':
      return WarningOutlined;
    case 'FrownOutlined':
      return FrownOutlined;
    case 'SmileOutlined':
      return SmileOutlined;
    case 'MehOutlined':
      return MehOutlined;
    case 'HeartOutlined':
      return HeartOutlined;
    case 'TrophyOutlined':
      return TrophyOutlined;
    case 'CrownOutlined':
      return CrownOutlined;
    case 'GoldOutlined':
      return GoldOutlined;
    case 'FlagOutlined':
      return FlagOutlined;
    case 'GlobalOutlined':
      return GlobalOutlined;
    case 'CloudOutlined':
      return CloudOutlined;
    case 'EnvironmentOutlined':
      return EnvironmentOutlined;
    case 'BankOutlined':
      return BankOutlined;
    case 'CarOutlined':
      return CarOutlined;
    case 'ShoppingOutlined':
      return ShoppingOutlined;
    case 'ShoppingCartOutlined':
      return ShoppingCartOutlined;
    case 'ShopOutlined':
      return ShopOutlined;
    case 'MedicineBoxOutlined':
      return MedicineBoxOutlined;
    case 'RestOutlined':
      return RestOutlined;
    case 'GiftOutlined':
      return GiftOutlined;
    case 'FireOutlined':
      return FireOutlined;
    case 'SkinOutlined':
      return SkinOutlined;
    case 'VideoCameraAddOutlined':
      return VideoCameraAddOutlined;
    case 'SoundOutlined':
      return SoundOutlined;
    case 'PayCircleOutlined':
      return PayCircleOutlined;
    case 'CalculatorOutlined':
      return CalculatorOutlined;
    case 'InteractionOutlined':
      return InteractionOutlined;
    case 'HourglassOutlined':
      return HourglassOutlined;
    case 'KeyOutlined':
      return KeyOutlined;
    case 'TagOutlined':
      return TagOutlined;
    case 'TagsOutlined':
      return TagsOutlined;
    case 'ScissorOutlined':
      return ScissorOutlined;
    case 'PaperClipOutlined':
      return PaperClipOutlined;
    case 'CopyOutlined':
      return CopyOutlined;
    case 'SnippetsOutlined':
      return SnippetsOutlined;
    case 'DiffOutlined':
      return DiffOutlined;
    case 'HighlightOutlined':
      return HighlightOutlined;
    case 'BoxPlotOutlined':
      return BoxPlotOutlined;
    case 'FundOutlined':
      return FundOutlined;
    case 'SlidersOutlined':
      return SlidersOutlined;
    case 'HddOutlined':
      return HddOutlined;
    case 'DatabaseOutlined':
      return DatabaseOutlined;
    case 'ContainerOutlined':
      return ContainerOutlined;
    case 'ClusterOutlined':
      return ClusterOutlined;
    case 'ControlOutlined':
      return ControlOutlined;
    case 'DashboardOutlined':
      return DashboardOutlined;
    case 'BuildOutlined':
      return BuildOutlined;
    case 'ExperimentOutlined':
      return ExperimentOutlined;
    case 'ThunderboltOutlined':
      return ThunderboltOutlined;
    case 'RocketOutlined':
      return RocketOutlined;
    case 'BellOutlined':
      return BellOutlined;
    case 'OpenAIOutlined':
      return OpenAIOutlined;
    case 'GoogleOutlined':
      return GoogleOutlined;
    case 'AppleOutlined':
      return AppleOutlined;
    case 'AndroidOutlined':
      return AndroidOutlined;
    case 'WindowsOutlined':
      return WindowsOutlined;
    case 'IeOutlined':
      return IeOutlined;
    case 'GithubOutlined':
      return GithubOutlined;
    case 'GitlabOutlined':
      return GitlabOutlined;
    case 'LinkedinOutlined':
      return LinkedinOutlined;
    case 'PinterestOutlined':
      return PinterestOutlined;
    case 'SkypeOutlined':
      return SkypeOutlined;
    case 'SlackOutlined':
      return SlackOutlined;
    case 'SlackSquareOutlined':
      return SlackSquareOutlined;
    case 'TwitchOutlined':
      return TwitchOutlined;
    case 'TwitterOutlined':
      return TwitterOutlined;
    case 'WechatOutlined':
      return WechatOutlined;
    case 'WeiboCircleOutlined':
      return WeiboCircleOutlined;
    case 'WeiboOutlined':
      return WeiboOutlined;
    case 'WeiboSquareOutlined':
      return WeiboSquareOutlined;
    case 'YahooOutlined':
      return YahooOutlined;
    case 'YoutubeOutlined':
      return YoutubeOutlined;
    case 'YuqueOutlined':
      return YuqueOutlined;
    case 'ZhihuOutlined':
      return ZhihuOutlined;
    case 'CodepenOutlined':
      return CodepenOutlined;
    case 'CodeSandboxOutlined':
      return CodeSandboxOutlined;
    case 'ChromeOutlined':
      return ChromeOutlined;
    case 'AmazonOutlined':
      return AmazonOutlined;
    case 'AlibabaOutlined':
      return AlibabaOutlined;
    case 'AliyunOutlined':
      return AliyunOutlined;
    case 'AntCloudOutlined':
      return AntCloudOutlined;
    case 'FontSizeOutlined':
      return FontSizeOutlined;
    case 'ForkOutlined':
      return ForkOutlined;
    case 'ShrinkOutlined':
      return ShrinkOutlined;
    case 'ArrowsAltOutlined':
      return ArrowsAltOutlined;
    case 'VerticalAlignTopOutlined':
      return VerticalAlignTopOutlined;
    case 'VerticalAlignMiddleOutlined':
      return VerticalAlignMiddleOutlined;
    case 'VerticalAlignBottomOutlined':
      return VerticalAlignBottomOutlined;
    case 'RollbackOutlined':
      return RollbackOutlined;
    case 'RedoOutlined':
      return RedoOutlined;
    case 'ForwardOutlined':
      return ForwardOutlined;
    case 'UndoOutlined':
      return UndoOutlined;
    case 'TransactionOutlined':
      return TransactionOutlined;
    case 'SaveOutlined':
      return SaveOutlined;
    case 'FileAddOutlined':
      return FileAddOutlined;
    case 'FileExcelOutlined':
      return FileExcelOutlined;
    case 'FileUnknownOutlined':
      return FileUnknownOutlined;
    case 'FilePdfOutlined':
      return FilePdfOutlined;
    case 'FileZipOutlined':
      return FileZipOutlined;
    case 'FilePptOutlined':
      return FilePptOutlined;
    case 'FileMarkdownOutlined':
      return FileMarkdownOutlined;
    case 'AudioOutlined':
      return AudioOutlined;
    case 'FileWordOutlined':
      return FileWordOutlined;
    case 'PushpinOutlined':
      return PushpinOutlined;
    case 'CaretUpOutlined':
      return CaretUpOutlined;
    case 'CaretDownOutlined':
      return CaretDownOutlined;
    case 'CaretLeftOutlined':
      return CaretLeftOutlined;
    case 'CaretRightOutlined':
      return CaretRightOutlined;
    case 'UpOutlined':
      return UpOutlined;
    case 'DownOutlined':
      return DownOutlined;
    case 'LeftOutlined':
      return LeftOutlined;
    case 'RightOutlined':
      return RightOutlined;
    case 'DoubleLeftOutlined':
      return DoubleLeftOutlined;
    case 'DoubleRightOutlined':
      return DoubleRightOutlined;
    case 'VerticalLeftOutlined':
      return VerticalLeftOutlined;
    case 'VerticalRightOutlined':
      return VerticalRightOutlined;
    case 'EnterOutlined':
      return EnterOutlined;
    case 'RotateLeftOutlined':
      return RotateLeftOutlined;
    case 'RotateRightOutlined':
      return RotateRightOutlined;
    case 'PicCenterOutlined':
      return PicCenterOutlined;
    case 'PicLeftOutlined':
      return PicLeftOutlined;
    case 'PicRightOutlined':
      return PicRightOutlined;
    case 'RadiusUpleftOutlined':
      return RadiusUpleftOutlined;
    case 'RadiusUprightOutlined':
      return RadiusUprightOutlined;
    case 'RadiusBottomleftOutlined':
      return RadiusBottomleftOutlined;
    case 'RadiusBottomrightOutlined':
      return RadiusBottomrightOutlined;
    case 'BoldOutlined':
      return BoldOutlined;
    case 'FontColorsOutlined':
      return FontColorsOutlined;
    case 'BackwardOutlined':
      return BackwardOutlined;
    case 'FastBackwardOutlined':
      return FastBackwardOutlined;
    case 'StepBackwardOutlined':
      return StepBackwardOutlined;
    case 'StepForwardOutlined':
      return StepForwardOutlined;
    case 'FastForwardOutlined':
      return FastForwardOutlined;
    case 'FunctionOutlined':
      return FunctionOutlined;
    case 'ImportOutlined':
      return ImportOutlined;
    case 'InboxOutlined':
      return InboxOutlined;
    case 'InfoOutlined':
      return InfoOutlined;
    case 'InsertRowAboveOutlined':
      return InsertRowAboveOutlined;
    case 'InsertRowBelowOutlined':
      return InsertRowBelowOutlined;
    case 'InsertRowLeftOutlined':
      return InsertRowLeftOutlined;
    case 'InsertRowRightOutlined':
      return InsertRowRightOutlined;
    case 'ItalicOutlined':
      return ItalicOutlined;
    case 'JavaOutlined':
      return JavaOutlined;
    case 'JavaScriptOutlined':
      return JavaScriptOutlined;
    case 'LineHeightOutlined':
      return LineHeightOutlined;
    case 'LineOutlined':
      return LineOutlined;
    case 'LinuxOutlined':
      return LinuxOutlined;
    case 'MacCommandOutlined':
      return MacCommandOutlined;
    case 'MergeCellsOutlined':
      return MergeCellsOutlined;
    case 'MergeOutlined':
      return MergeOutlined;
    case 'MoonOutlined':
      return MoonOutlined;
    case 'MutedOutlined':
      return MutedOutlined;
    case 'NodeIndexOutlined':
      return NodeIndexOutlined;
    case 'NumberOutlined':
      return NumberOutlined;
    case 'ProductOutlined':
      return ProductOutlined;
    case 'PythonOutlined':
      return PythonOutlined;
    case 'QqOutlined':
      return QqOutlined;
    case 'ReadOutlined':
      return ReadOutlined;
    case 'RetweetOutlined':
      return RetweetOutlined;
    case 'RiseOutlined':
      return RiseOutlined;
    case 'ShakeOutlined':
      return ShakeOutlined;
    case 'SelectOutlined':
      return SelectOutlined;
    case 'SplitCellsOutlined':
      return SplitCellsOutlined;
    case 'StrikethroughOutlined':
      return StrikethroughOutlined;
    case 'SubnodeOutlined':
      return SubnodeOutlined;
    case 'SunOutlined':
      return SunOutlined;
    case 'SwapOutlined':
      return SwapOutlined;
    case 'ToTopOutlined':
      return ToTopOutlined;
    case 'TruckOutlined':
      return TruckOutlined;
    case 'VerifiedOutlined':
      return VerifiedOutlined;
    case 'XOutlined':
      return XOutlined;
    case 'StockOutlined':
      return StockOutlined;
    case 'TrademarkOutlined':
      return TrademarkOutlined;
    case 'CopyrightOutlined':
      return CopyrightOutlined;
    case 'SecurityScanOutlined':
      return SecurityScanOutlined;
    case 'FileProtectOutlined':
      return FileProtectOutlined;
    case 'FileSyncOutlined':
      return FileSyncOutlined;
    case 'FileExclamationOutlined':
      return FileExclamationOutlined;
    case 'BranchesOutlined':
      return BranchesOutlined;
    case 'DisconnectOutlined':
      return DisconnectOutlined;
    case 'Loading3QuartersOutlined':
      return Loading3QuartersOutlined;
    case 'LoadingOutlined':
      return LoadingOutlined;
    case 'EllipsisOutlined':
      return EllipsisOutlined;
    case 'FullscreenOutlined':
      return FullscreenOutlined;
    case 'FullscreenExitOutlined':
      return FullscreenExitOutlined;
    case 'QuestionOutlined':
      return QuestionOutlined;
    case 'PlusCircleOutlined':
      return PlusCircleOutlined;
    case 'MinusCircleOutlined':
      return MinusCircleOutlined;
    case 'PlusSquareOutlined':
      return PlusSquareOutlined;
    case 'MinusSquareOutlined':
      return MinusSquareOutlined;
    case 'ClockCircleOutlined':
      return ClockCircleOutlined;
    case 'MenuOutlined':
      return MenuOutlined;
    case 'AlignLeftOutlined':
      return AlignLeftOutlined;
    case 'AlignCenterOutlined':
      return AlignCenterOutlined;
    case 'AlignRightOutlined':
      return AlignRightOutlined;
    case 'DashOutlined':
      return DashOutlined;
    case 'SmallDashOutlined':
      return SmallDashOutlined;
    case 'NodeCollapseOutlined':
      return NodeCollapseOutlined;
    case 'NodeExpandOutlined':
      return NodeExpandOutlined;
    case 'OneToOneOutlined':
      return OneToOneOutlined;
    case 'PartitionOutlined':
      return PartitionOutlined;
    case 'PullRequestOutlined':
      return PullRequestOutlined;
    case 'SignatureOutlined':
      return SignatureOutlined;
    case 'SwapLeftOutlined':
      return SwapLeftOutlined;
    case 'SwapRightOutlined':
      return SwapRightOutlined;
    case 'TranslationOutlined':
      return TranslationOutlined;
    case 'UngroupOutlined':
      return UngroupOutlined;
    case 'WhatsAppOutlined':
      return WhatsAppOutlined;
    case 'WifiOutlined':
      return WifiOutlined;
    case 'ZoomInOutlined':
      return ZoomInOutlined;
    case 'ZoomOutOutlined':
      return ZoomOutOutlined;
    case 'AccountBookOutlined':
      return AccountBookOutlined;
    case 'ApiOutlined':
      return ApiOutlined;
    case 'BookOutlined':
      return BookOutlined;
    case 'BugOutlined':
      return BugOutlined;
    case 'BulbOutlined':
      return BulbOutlined;
    case 'CameraOutlined':
      return CameraOutlined;
    case 'CompassOutlined':
      return CompassOutlined;
    case 'CoffeeOutlined':
      return CoffeeOutlined;
    case 'FileDoneOutlined':
      return FileDoneOutlined;
    case 'FileGifOutlined':
      return FileGifOutlined;
    case 'FolderAddOutlined':
      return FolderAddOutlined;
    case 'FolderOutlined':
      return FolderOutlined;
    case 'FolderOpenOutlined':
      return FolderOpenOutlined;
    case 'HistoryOutlined':
      return HistoryOutlined;
    case 'MonitorOutlined':
      return MonitorOutlined;
    case 'MoreOutlined':
      return MoreOutlined;
    case 'PoundOutlined':
      return PoundOutlined;
    case 'GifOutlined':
      return GifOutlined;
    case 'HarmonyOSOutlined':
      return HarmonyOSOutlined;
    case 'KubernetesOutlined':
      return KubernetesOutlined;
    case 'RubyOutlined':
      return RubyOutlined;
    case 'SpotifyOutlined':
      return SpotifyOutlined;
    // Filled 图标
    case 'AlertFilled':
      return AlertFilled;
    case 'SwitcherFilled':
      return SwitcherFilled;
    case 'TaobaoCircleFilled':
      return TaobaoCircleFilled;
    case 'TaobaoSquareFilled':
      return TaobaoSquareFilled;
    case 'TwitterCircleFilled':
      return TwitterCircleFilled;
    case 'TwitterSquareFilled':
      return TwitterSquareFilled;
    case 'UsbFilled':
      return UsbFilled;
    case 'DribbbleSquareFilled':
      return DribbbleSquareFilled;
    case 'FacebookFilled':
      return FacebookFilled;
    case 'InstagramFilled':
      return InstagramFilled;
    case 'SignalFilled':
      return SignalFilled;
    // TwoTone 图标 (按字母顺序排列)
    case 'AccountBookTwoTone':
      return AccountBookTwoTone;
    case 'AlertTwoTone':
      return AlertTwoTone;
    case 'ApiTwoTone':
      return ApiTwoTone;
    case 'AppstoreTwoTone':
      return AppstoreTwoTone;
    case 'AudioTwoTone':
      return AudioTwoTone;
    case 'BankTwoTone':
      return BankTwoTone;
    case 'BellTwoTone':
      return BellTwoTone;
    case 'BookTwoTone':
      return BookTwoTone;
    case 'BoxPlotTwoTone':
      return BoxPlotTwoTone;
    case 'BugTwoTone':
      return BugTwoTone;
    case 'BuildTwoTone':
      return BuildTwoTone;
    case 'BulbTwoTone':
      return BulbTwoTone;
    case 'CalculatorTwoTone':
      return CalculatorTwoTone;
    case 'CalendarTwoTone':
      return CalendarTwoTone;
    case 'CameraTwoTone':
      return CameraTwoTone;
    case 'CarTwoTone':
      return CarTwoTone;
    case 'CarryOutTwoTone':
      return CarryOutTwoTone;
    case 'CheckCircleTwoTone':
      return CheckCircleTwoTone;
    case 'CheckSquareTwoTone':
      return CheckSquareTwoTone;
    case 'CiCircleTwoTone':
      return CiCircleTwoTone;
    case 'CiTwoTone':
      return CiTwoTone;
    case 'ClockCircleTwoTone':
      return ClockCircleTwoTone;
    case 'CloseCircleTwoTone':
      return CloseCircleTwoTone;
    case 'CloseSquareTwoTone':
      return CloseSquareTwoTone;
    case 'CloudTwoTone':
      return CloudTwoTone;
    case 'CodeTwoTone':
      return CodeTwoTone;
    case 'CompassTwoTone':
      return CompassTwoTone;
    case 'ContactsTwoTone':
      return ContactsTwoTone;
    case 'ContainerTwoTone':
      return ContainerTwoTone;
    case 'ControlTwoTone':
      return ControlTwoTone;
    case 'CopyrightCircleTwoTone':
      return CopyrightCircleTwoTone;
    case 'CopyrightTwoTone':
      return CopyrightTwoTone;
    case 'CopyTwoTone':
      return CopyTwoTone;
    case 'CreditCardTwoTone':
      return CreditCardTwoTone;
    case 'CrownTwoTone':
      return CrownTwoTone;
    case 'CustomerServiceTwoTone':
      return CustomerServiceTwoTone;
    case 'DashboardTwoTone':
      return DashboardTwoTone;
    case 'DatabaseTwoTone':
      return DatabaseTwoTone;
    case 'DeleteTwoTone':
      return DeleteTwoTone;
    case 'DiffTwoTone':
      return DiffTwoTone;
    case 'DislikeTwoTone':
      return DislikeTwoTone;
    case 'DollarCircleTwoTone':
      return DollarCircleTwoTone;
    case 'DollarTwoTone':
      return DollarTwoTone;
    case 'DownCircleTwoTone':
      return DownCircleTwoTone;
    case 'DownSquareTwoTone':
      return DownSquareTwoTone;
    case 'EditTwoTone':
      return EditTwoTone;
    case 'EnvironmentTwoTone':
      return EnvironmentTwoTone;
    case 'EuroCircleTwoTone':
      return EuroCircleTwoTone;
    case 'EuroTwoTone':
      return EuroTwoTone;
    case 'ExclamationCircleTwoTone':
      return ExclamationCircleTwoTone;
    case 'ExperimentTwoTone':
      return ExperimentTwoTone;
    case 'EyeInvisibleTwoTone':
      return EyeInvisibleTwoTone;
    case 'EyeTwoTone':
      return EyeTwoTone;
    case 'FileAddTwoTone':
      return FileAddTwoTone;
    case 'FileExcelTwoTone':
      return FileExcelTwoTone;
    case 'FileExclamationTwoTone':
      return FileExclamationTwoTone;
    case 'FileImageTwoTone':
      return FileImageTwoTone;
    case 'FileMarkdownTwoTone':
      return FileMarkdownTwoTone;
    case 'FilePdfTwoTone':
      return FilePdfTwoTone;
    case 'FilePptTwoTone':
      return FilePptTwoTone;
    case 'FileTextTwoTone':
      return FileTextTwoTone;
    case 'FileTwoTone':
      return FileTwoTone;
    case 'FileUnknownTwoTone':
      return FileUnknownTwoTone;
    case 'FileWordTwoTone':
      return FileWordTwoTone;
    case 'FileZipTwoTone':
      return FileZipTwoTone;
    case 'FilterTwoTone':
      return FilterTwoTone;
    case 'FireTwoTone':
      return FireTwoTone;
    case 'FlagTwoTone':
      return FlagTwoTone;
    case 'FolderAddTwoTone':
      return FolderAddTwoTone;
    case 'FolderOpenTwoTone':
      return FolderOpenTwoTone;
    case 'FolderTwoTone':
      return FolderTwoTone;
    case 'FrownTwoTone':
      return FrownTwoTone;
    case 'FundTwoTone':
      return FundTwoTone;
    case 'FunnelPlotTwoTone':
      return FunnelPlotTwoTone;
    case 'GiftTwoTone':
      return GiftTwoTone;
    case 'GoldTwoTone':
      return GoldTwoTone;
    case 'HddTwoTone':
      return HddTwoTone;
    case 'HeartTwoTone':
      return HeartTwoTone;
    case 'HighlightTwoTone':
      return HighlightTwoTone;
    case 'HomeTwoTone':
      return HomeTwoTone;
    case 'HourglassTwoTone':
      return HourglassTwoTone;
    case 'Html5TwoTone':
      return Html5TwoTone;
    case 'IdcardTwoTone':
      return IdcardTwoTone;
    case 'InfoCircleTwoTone':
      return InfoCircleTwoTone;
    case 'InsuranceTwoTone':
      return InsuranceTwoTone;
    case 'InteractionTwoTone':
      return InteractionTwoTone;
    case 'LayoutTwoTone':
      return LayoutTwoTone;
    case 'LeftCircleTwoTone':
      return LeftCircleTwoTone;
    case 'LeftSquareTwoTone':
      return LeftSquareTwoTone;
    case 'LikeTwoTone':
      return LikeTwoTone;
    case 'LockTwoTone':
      return LockTwoTone;
    case 'MailTwoTone':
      return MailTwoTone;
    case 'MedicineBoxTwoTone':
      return MedicineBoxTwoTone;
    case 'MehTwoTone':
      return MehTwoTone;
    case 'MessageTwoTone':
      return MessageTwoTone;
    case 'MinusCircleTwoTone':
      return MinusCircleTwoTone;
    case 'MinusSquareTwoTone':
      return MinusSquareTwoTone;
    case 'MobileTwoTone':
      return MobileTwoTone;
    case 'MoneyCollectTwoTone':
      return MoneyCollectTwoTone;
    case 'NotificationTwoTone':
      return NotificationTwoTone;
    case 'PauseCircleTwoTone':
      return PauseCircleTwoTone;
    case 'PhoneTwoTone':
      return PhoneTwoTone;
    case 'PictureTwoTone':
      return PictureTwoTone;
    case 'PieChartTwoTone':
      return PieChartTwoTone;
    case 'PlayCircleTwoTone':
      return PlayCircleTwoTone;
    case 'PlaySquareTwoTone':
      return PlaySquareTwoTone;
    case 'PlusCircleTwoTone':
      return PlusCircleTwoTone;
    case 'PlusSquareTwoTone':
      return PlusSquareTwoTone;
    case 'PoundCircleTwoTone':
      return PoundCircleTwoTone;
    case 'PrinterTwoTone':
      return PrinterTwoTone;
    case 'ProfileTwoTone':
      return ProfileTwoTone;
    case 'ProjectTwoTone':
      return ProjectTwoTone;
    case 'PropertySafetyTwoTone':
      return PropertySafetyTwoTone;
    case 'PushpinTwoTone':
      return PushpinTwoTone;
    case 'QuestionCircleTwoTone':
      return QuestionCircleTwoTone;
    case 'ReconciliationTwoTone':
      return ReconciliationTwoTone;
    case 'RedEnvelopeTwoTone':
      return RedEnvelopeTwoTone;
    case 'RestTwoTone':
      return RestTwoTone;
    case 'RightCircleTwoTone':
      return RightCircleTwoTone;
    case 'RightSquareTwoTone':
      return RightSquareTwoTone;
    case 'RocketTwoTone':
      return RocketTwoTone;
    case 'SafetyCertificateTwoTone':
      return SafetyCertificateTwoTone;
    case 'SaveTwoTone':
      return SaveTwoTone;
    case 'ScheduleTwoTone':
      return ScheduleTwoTone;
    case 'SecurityScanTwoTone':
      return SecurityScanTwoTone;
    case 'SettingTwoTone':
      return SettingTwoTone;
    case 'ShoppingTwoTone':
      return ShoppingTwoTone;
    case 'ShopTwoTone':
      return ShopTwoTone;
    case 'SkinTwoTone':
      return SkinTwoTone;
    case 'SlidersTwoTone':
      return SlidersTwoTone;
    case 'SmileTwoTone':
      return SmileTwoTone;
    case 'SnippetsTwoTone':
      return SnippetsTwoTone;
    case 'SoundTwoTone':
      return SoundTwoTone;
    case 'StarTwoTone':
      return StarTwoTone;
    case 'StopTwoTone':
      return StopTwoTone;
    case 'SwitcherTwoTone':
      return SwitcherTwoTone;
    case 'TabletTwoTone':
      return TabletTwoTone;
    case 'TagsTwoTone':
      return TagsTwoTone;
    case 'TagTwoTone':
      return TagTwoTone;
    case 'ThunderboltTwoTone':
      return ThunderboltTwoTone;
    case 'ToolTwoTone':
      return ToolTwoTone;
    case 'TrademarkCircleTwoTone':
      return TrademarkCircleTwoTone;
    case 'TrophyTwoTone':
      return TrophyTwoTone;
    case 'UnlockTwoTone':
      return UnlockTwoTone;
    case 'UpCircleTwoTone':
      return UpCircleTwoTone;
    case 'UpSquareTwoTone':
      return UpSquareTwoTone;
    case 'UsbTwoTone':
      return UsbTwoTone;
    case 'VideoCameraTwoTone':
      return VideoCameraTwoTone;
    case 'WalletTwoTone':
      return WalletTwoTone;
    case 'WarningTwoTone':
      return WarningTwoTone;
    default:
      return null;
  }
};

export function enhancedConvertIcon(
  iconName: string | undefined,
): React.ReactNode {
  if (!iconName || typeof iconName !== 'string') {
    return undefined;
  }

  const cleanName = iconName.replace(/['"]/g, '').trim();
  const lowerName = cleanName.toLowerCase();

  if (FIXED_ICON_MAPPING[lowerName]) {
    const mappedName = FIXED_ICON_MAPPING[lowerName];
    const IconComponent = getIconComponent(mappedName);
    if (IconComponent) {
      return React.createElement(IconComponent);
    }
  }

  const IconComponent = getIconComponent(cleanName);
  if (IconComponent) {
    return React.createElement(IconComponent);
  }

  const capitalizedIconName =
    cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
  const CapitalizedIconComponent = getIconComponent(capitalizedIconName);
  if (CapitalizedIconComponent) {
    return React.createElement(CapitalizedIconComponent);
  }

  return undefined;
}

export { FIXED_ICON_MAPPING, getIconComponent };
